import { ConfigProvider, Form, Input, message, Modal } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { SaveButton } from "@/app/home/components/table/SaveButton";
import { AppRoleRepo } from "@/core/repos/tables/app-role.repo";
import { AppRoleModel } from "@/core/models/app-role.model";

const appRoleRepo = container.get(AppRoleRepo);

interface CreateModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data: AppRoleModel,
}

const INPUT_WIDTH = 450;

export const DetailModal: React.FC<CreateModalProps> = ({isModalOpen, setIsModalOpen, data}) => {
    const [form] = Form.useForm<AppRoleModel>();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false)
    //Attach hooks to handle data changes
    const handleDataChange = async () => {
        form.setFieldsValue(data);
        if (data.id&&data.id.length>0) {
            setIsEdit(true);
        } else {
            setIsEdit(false);
        }
    }
    useEffect(()=>{
        handleDataChange();
    }, [data])

    const init = async () => {}
    //componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {init()}, []);

    const handleSave = async () => {
        try {
            setLoading(true);
            const formData = await form.validateFields();
            if (isEdit) {
                formData.id = data.id;
                const result = await appRoleRepo.update({...data, ...formData});
                setIsModalOpen(false);
                if (result) {
                    message.success({
                        content: "Đã cập nhật"
                    })
                } else {
                    message.error({
                        content: "Cập nhật thất bại"
                    })
                }
            } else {
                const result = await appRoleRepo.create({...data, ...formData});
                setIsModalOpen(false);
                if (result) {
                    message.success({
                        content: "Thêm bản ghi mới thành công"
                    })
                } else {
                    message.error({
                        content: "Thêm bản ghi mới thất bại"
                    })
                }
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };
      

    return (
        <ConfigProvider theme={MODAL_THEME}>
            <Modal open={isModalOpen} onCancel={handleCancel} width={510} centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <div key={1} className="w-full flex flex-row justify-end px-1.5">
                        <SaveButton isEdit={isEdit} loading={loading} onClick={handleSave}/>
                    </div>,
                ]}
            >
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">CHI TIẾT BẢN GHI</p>
                </div>
                <div className="flex flex-row justify-center mt-6">
                    <Form<AppRoleModel>
                        name="basic"
                        className="flex flex-col items-start"
                        autoComplete="off"
                        labelAlign="left"
                        layout="vertical"
                        form={form}
                    >
                        <Form.Item<AppRoleModel>
                            label="Tên Nhóm tài khoản"
                            name="name"
                            rules={[
                                { required: true, message: 'Trường này là bắt buộc!' },
                                { pattern: /^[a-zA-Z0-9_]+$/, message: `Các ký tự cho phép bao gồm 'a-z', 'A-Z', '0-9' và '_'!` }
                            ]}
                        >
                            <Input placeholder="Nhập tên Nhóm tài khoản" style={{width: INPUT_WIDTH}} disabled={isEdit}></Input>
                        </Form.Item>
                        <Form.Item<AppRoleModel>
                            label="Mô tả"
                            name="description"
                        >
                            <Input.TextArea placeholder="Nhập mô tả" style={{width: INPUT_WIDTH, height: 202, resize: "none"}}></Input.TextArea>
                        </Form.Item>
                    </Form>
                </div>
                <div className="mb-5 mx-2 border-t border-dashed border-gray-300"></div>
            </Modal>
        </ConfigProvider>
    )
}
